<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <!-- Page Content -->
    <div class="content container-fluid">
      <!-- Page Header -->
      <location-header :title="title" :path="path" :text="text" :text1="text1" @addLocationClick="addLocationClick" />
      <!-- /Page Header -->

      <!-- Search Filter -->
      <!-- <search-filter @searchClicked="searchClicked"></search-filter> -->
      <!-- /Search Filter -->

      <div class="row">
        <div class="col-md-12">
          <!-- <div class="showentries mb-3">
            <label>Show
              <select v-model="perPage" @change="getUsers" style="outline: none">
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
              entries</label>
          </div> -->
          <div v-if="!loader">
            <div class="table-responsive">

              <a-table class="stripped table-hover" :columns="columns" :data-source="locationIdOptions"
                :pagination="false" v-if="locationIdOptions">
                <template #bodyCell="{ column, record }">
                  <template v-if="column.key === 'name'">
                    {{ record.name }}
                  </template>
                  <template v-else-if="column.key === 'role_count'">
                    {{ record.role_count }}
                  </template>
                  <template v-else-if="column.key === 'user_count'">
                    {{ record.user_count }}
                  </template>
                  <template v-else-if="column.key === 'action'">
                    <div>
                      <div class="dropdown dropdown-action">
                        <a href="javascript:;" class="action-icon dropdown-toggle" data-bs-toggle="dropdown"
                          aria-expanded="false"><i class="material-icons">more_vert</i></a>
                        <div class="dropdown-menu dropdown-menu-right">

                          <a class="dropdown-item" href="javascript:;" data-bs-toggle="modal"
                            data-bs-target="#update_location" @click="updateLocationClick(record)"><i
                              class="fa-solid fa-pencil m-r-5"></i>Edit</a>
                          <!-- <a class="dropdown-item" href="javascript:;" data-bs-toggle="modal"
                          data-bs-target="#edit-schedule-template-user" @click="addUsersClicked(record)"><i
                            class="fa-solid fa-trash m-r-5"></i>Delete</a> -->
                        </div>
                      </div>
                    </div>
                  </template>
                </template>
              </a-table>
              <div v-else>
                <div class="card text-center">
                  <div class="card-body">
                    <img src="../../../assets/img/avatar/no-data.png" alt="no-data" srcset="" class="responsive-img">
                    <p>No Location have been added.</p>
                  </div>
                </div>
              </div>
              <!-- <div class="d-flex justify-content-center">
              <a-pagination v-model:current="current" v-model:pageSize="perPage" :total="total" @change="getUsers"
                show-less-items class="mt-3 ">
                <template #itemRender="{ type, originalElement }">
                  <a v-if="type === 'prev'">Previous</a>
                  <a v-else-if="type === 'next'">Next</a>
                  <component :is="originalElement" v-else></component>
                </template>
              </a-pagination>
            </div> -->
            </div>

          </div>
          <div class="d-flex justify-content-center text-center mt-5" v-else>
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Content -->

    <!-- <employee-modal @userAdded="getUsers"></employee-modal>-->
    <!-- <edit-schedule-template-user-modal ref="editScheduleUsers" @editedShift="getUsers"></edit-schedule-template-user-modal>
     <edit-role-modal ref="editScheduleRoles" @editedShift="getUsers"></edit-role-modal> -->
    <add-location-modal ref="addLocation" @locationModal="getLocations"></add-location-modal>
    <update-location-modal ref="updateLocation" @locationModal="getLocations" :latitude="selectedLocation.latitude"
      :longitude="selectedLocation.longitude" :location-data="selectedLocation"></update-location-modal>

    <!--<add-face-template-modal ref="addface"></add-face-template-modal> -->
  </div>
  <!-- /Page Wrapper -->
</template>

<script>
import axios from 'axios';
import { VUE_APP_API_BASE_URL } from "../../../config";
import { getImage } from "@/utils/util-funcitons";
const columns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    sorter: {
      compare: (a, b) => {
        a = a.name.toLowerCase();
        b = b.name.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Latitude",
    dataIndex: "latitude",
    key: "latitude"
  },
  {
    title: "Longitude",
    dataIndex: "longitude",
    key: "longitude"
  },
  {
    title: "Radius",
    dataIndex: "radius",
    key: "radius"
  },
  {
    title: "Action",
    // sorter: true,
    key: "action",
  },
];

export default {
  data() {
    return {
      columns,
      title: "Locations",
      path: "Dashboard",
      text: "Locations",
      text1: "Add Location",
      scheduleData: [],
      perPage: 10,
      current: 1,
      total: 0,
      employee_code: "",
      employee_name: "",
      loader: false,
      locationIdOptions: [],
      selectedLocation: {
        id: null,
        name: '',
        latitude: 0.14405508452768728,
        longitude: 51.4893335,
        radius: 100
      }
    };
  },
  mounted() {
    this.getLocations()
  },

  methods: {
    // searchClicked(data) {
    //   this.employee_code = data.employee_code;
    //   this.employee_name = data.employee_name;
    //   this.company_role_id = data.company_role_id;
    //   this.getUsers();
    // },
    getImage,
    // getUsers() {
    //   this.loader = true;
    //   if(Number(this.perPage) >= this.total){
    //           this.current = 1
    //   }
    //   const params = {
    //     per_page: this.perPage
    //   //   employee_code: this.employee_code,
    //   //   employee_name: this.employee_name,
    //   //   company_role_id: this.company_role_id
    //   }
    //   axios.get(`${process.env.VUE_APP_API_BASE_URL}/schedule-template/get?page=${this.current}`, { params: params })
    //     .then((response) => {
    //       console.log(response, "response");
    //       if (response.data.status) {
    //         this.scheduleData = response.data.data;
    //         console.log(response.data.data, " this.scheduleData");
    //         this.current = response.data.data.current_page;

    //         this.total = response.data.data.total;
    //       } else {
    //         this.errorMessage = response.data.message ?? "";
    //       }
    //     })
    //     .finally(() => {
    //       this.loader = false;
    //     });
    // },




    async getLocations() {
      this.loader = true;
      await axios.get(`${VUE_APP_API_BASE_URL}/location/all`)
        .then((response) => {
          if (response.data.status) {
            this.locationIdOptions = response.data.data
            // this.locationIdOptions.forEach(element => {
            //   delete element['created_at'];
            //   delete element['updated_at'];
            //   delete element['latitude'];
            //   delete element['longitude'];
            //   element['text'] = element['name'];
            //   delete element['name'];
            // }
            // )
          } else {
            this.errorMessage = response.data.message || response.data.errors;
          }
        }).catch(function (error) {
          console.log(error);
        })
        .finally(() => {
          this.loader = false;
        });
    },

    updateLocationClick(data) {
      this.selectedLocation = { ...data };
      this.$refs.updateLocation.updateValues(data);
    },


    // leavesClicked(record){
    //   this.$router.push({ path: '/employee/leaves-employee', query: { id: record.id } })
    //   console.log(record.id);
    // },

    // attendanceClicked(record){
    //   this.$router.push({ path: '/employee/attendance-employee', query: { id: record.id } })
    //   console.log(record.id);
    // },
    // viewClicked(record) {
    //   this.$refs.addSchedule.showView(record.id);
    // },
    //  editClicked(record) {
    //   this.$refs.addSchedule.editView(record.id);
    // },
    // addUsersClicked(record){
    //   this.$refs.editScheduleUsers.updateId(record.id);
    // },
    // addRolesClicked(record){
    //   this.$refs.editScheduleRoles.updateId(record.id);
    // },
    // addLocationClick(record) {
    //   this.$refs.addLocation.edit(record.id);
    // },

  }
};
</script>
<style scoped>
:where(.css-dev-only-do-not-override-1hsjdkk).ant-pagination .ant-pagination-prev,
:where(.css-dev-only-do-not-override-1hsjdkk).ant-pagination .ant-pagination-next {
  background-color: #ffffff00 !important;
}

.inline-item {
  display: inline-block;
  margin-right: 2px;
  /* Adjust spacing between items */
}

.table-responsive {
  height: 100vh;
  overflow: visible !important;
}

.responsive-img {
  width: 100%;
  max-width: 100px;
  height: auto;
}
</style>
